





































































































































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings'
import { AppModule } from '@/store/modules/app';
import BranchDto from '@/models/Branches/BranchDto';
import GiganautVue from '@/components/Shared/GiganautVue';
import DeskDto from '@/models/Desks/DeskDto';
import DeskEdit from '@/components/Desks/DeskEdit.vue';
import DeskExternalAccountingEdit from '@/components/Desks/DeskExternalAccountingEdit.vue';
import DeskExternalPayrollEdit from '@/components/Desks/DeskExternalPayrollEdit.vue';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import WorkerBulkInviteSearchRequest from '@/models/Workers/WorkerBulkInviteSearchRequest';

@Component({
  name: 'Desk',
  components: { DeskEdit, DeskExternalAccountingEdit, DeskExternalPayrollEdit }
})
export default class extends GiganautVue {
    
    get currentDesk() {
        return AgencySettingsModule.currentDesk;
    }

    get currentBranch() {
        return AgencySettingsModule.currentBranch;
    }

    async bulkInviteWorkers() {
		const options: VuetifyConfirmObject = {
			buttonTrueText: "INVITE",
			buttonFalseText: "CANCEL",
			buttonTrueColor: "primary",
			buttonFalseColor: "primary",
		};
		const result = await this.$confirm(
			"Are you sure you want to invite all active workers linked to this desk? Note: workers who have already been invited will not be re-invited.",
			options
		);
		if (result) {
            const request = new WorkerBulkInviteSearchRequest();
            request.deskId = this.currentDesk.id;
            request.branchId = this.currentBranch.id;
			await AgencySettingsModule.deskBulkInviteWorkers(request);
		}
	}



}
